import { Link } from "react-router-dom";
import { Gamepad2 } from "lucide-react";
import { GLOSSARY, BUDGET_BANDS, BRANDS } from "@/data/static";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-border bg-graphite">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
          <div>
            <div className="flex items-center gap-2">
              <Gamepad2 className="h-5 w-5 text-neon" />
              <span className="font-display text-sm font-black tracking-wider text-white">
                GAMING<span className="text-neon">KITS</span>.ONLINE
              </span>
            </div>
            <p className="mt-3 text-xs leading-relaxed text-slate-400">
              Pakistan's gaming phone database. Compare gaming smartphones by budget, FPS and condition - then explore
              trusted buying options.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white">By Budget</h4>
            <ul className="mt-3 space-y-2 text-sm text-slate-400">
              {BUDGET_BANDS.map((b) => (
                <li key={b.slug}>
                  <Link to={`/category/${b.slug}`} className="hover:text-neon">{b.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white">Explore</h4>
            <ul className="mt-3 space-y-2 text-sm text-slate-400">
              <li><Link to="/fps-finder" className="hover:text-neon">FPS Finder</Link></li>
              <li><Link to="/compare" className="hover:text-neon">Compare Phones</Link></li>
              <li><Link to="/price-index" className="hover:text-neon">Price Index</Link></li>
              <li><Link to="/guides" className="hover:text-neon">Guides</Link></li>
              <li><Link to="/category/90fps-pubg-phones" className="hover:text-neon">90 FPS PUBG Phones</Link></li>
              <li><Link to="/category/cod-mobile-phones" className="hover:text-neon">CoD Mobile Phones</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white">Shop by Brand</h4>
            <ul className="mt-3 space-y-2 text-sm text-slate-400">
              {Object.entries(BRANDS).slice(0, 6).map(([slug, b]) => (
                <li key={slug}>
                  <Link to={`/brand/${slug}`} className="hover:text-neon">{b.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white">Gamer's Glossary</h4>
            <ul className="mt-3 flex flex-wrap gap-3 text-xs text-slate-400">
              {GLOSSARY.slice(0, 6).map((g) => (
                <li key={g.term}>
                  <Link to="/glossary" className="rounded-md border border-border bg-slateSurface px-2 py-1 hover:text-cyber">
                    {g.term}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 rounded-lg border border-cyber/20 bg-cyber/5 p-4 sm:flex-row sm:items-center">
          <p className="text-xs leading-relaxed text-slate-300">
            GamingKits.online is part of the{" "}
            <a href="https://phoneflip.pk" target="_blank" rel="noopener noreferrer nofollow" data-testid="footer-phoneflip-brand-link" className="font-semibold text-cyber hover:underline">
              PhoneFlip.pk
            </a>{" "}
            network - Pakistan's marketplace for buying & selling phones.
          </p>
          <div className="flex flex-wrap gap-4 text-xs font-medium">
            <a href="https://phoneflip.pk/new-phones" target="_blank" rel="noopener noreferrer nofollow" data-testid="footer-phoneflip-new" className="text-slate-300 hover:text-neon">New Phones</a>
            <a href="https://phoneflip.pk/used-phones" target="_blank" rel="noopener noreferrer nofollow" data-testid="footer-phoneflip-used" className="text-slate-300 hover:text-neon">Used Phones</a>
            <a href="https://phoneflip.pk/pta-calculator" target="_blank" rel="noopener noreferrer nofollow" data-testid="footer-phoneflip-pta" className="text-slate-300 hover:text-neon">PTA Calculator</a>
          </div>
        </div>

        <div className="mt-4 rounded-lg border border-border bg-slateSurface p-4 text-xs leading-relaxed text-slate-400">
          <strong className="text-slate-200">Disclaimer:</strong> Prices update live in PKR and FPS figures are real
          chipset benchmark averages; both can vary by city, seller, condition, software version, room temperature and
          game update. Thermal, gyro and PTA tax figures are not independently lab-tested. We are not affiliated with any
          brand, marketplace, OLX, PTA or third-party store. Outbound links are external and provided for convenience
          only. Content on CPID, patched devices and taxes is informational and not legal advice - verify current rules
          with official/relevant sources.
        </div>

        <p className="mt-6 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} GamingKits.online <Link to="/admin" className="hover:text-slate-300">Admin</Link>
        </p>
      </div>
    </footer>
  );
}
